(function () {
  'use strict';

  if (window.__pdpPopupInit) return;
  window.__pdpPopupInit = true;

  /* ---- scroll lock -------------------------------------------
     Mirrors the cart-drawer approach: toggle the theme's own
     .overflow-hidden class on body. No padding-right so sticky
     headers are not disturbed.
  ------------------------------------------------------------ */
  var _scrollLockCount = 0;

  function lockBodyScroll() {
    if (_scrollLockCount === 0) {
      document.body.classList.add('overflow-hidden');
    }
    _scrollLockCount++;
  }

  function unlockBodyScroll() {
    _scrollLockCount = Math.max(0, _scrollLockCount - 1);
    if (_scrollLockCount === 0) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  /* ---- open / close ------------------------------------------ */
  function openOverlay(overlay) {
    // Cancel any in-progress close
    if (overlay.classList.contains('is-closing')) {
      var panel = overlay.querySelector('.pdp-popup__panel');
      var oldHandler = overlay._pdpCloseHandler;
      if (oldHandler && panel) {
        panel.removeEventListener('transitionend', oldHandler);
      }
      delete overlay._pdpCloseHandler;
      overlay.classList.remove('is-closing');
      // The lockBodyScroll from the closing pass is still active — don't double-lock
    } else {
      lockBodyScroll();
    }

    var panel = overlay.querySelector('.pdp-popup__panel');
    if (panel) panel.style.willChange = 'transform, opacity';

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');

    var closeBtn = overlay.querySelector('.pdp-popup__close');
    if (closeBtn) {
      requestAnimationFrame(function () { closeBtn.focus(); });
    }
  }

  function closeOverlay(overlay) {
    if (!overlay.classList.contains('is-open')) return;

    var panel = overlay.querySelector('.pdp-popup__panel');
    if (panel) panel.style.willChange = 'transform, opacity';

    overlay.classList.remove('is-open');
    overlay.classList.add('is-closing');
    overlay.setAttribute('aria-hidden', 'true');

    function onTransitionEnd(e) {
      if (e.target !== panel) return;
      if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;

      if (panel) panel.removeEventListener('transitionend', onTransitionEnd);
      delete overlay._pdpCloseHandler;

      overlay.classList.remove('is-closing');
      if (panel) panel.style.willChange = '';

      unlockBodyScroll();
    }

    if (panel) {
      overlay._pdpCloseHandler = onTransitionEnd;
      panel.addEventListener('transitionend', onTransitionEnd);

      // Safety fallback for reduced-motion / no transition
      setTimeout(function () {
        if (overlay.classList.contains('is-closing')) {
          if (panel) panel.removeEventListener('transitionend', onTransitionEnd);
          delete overlay._pdpCloseHandler;
          overlay.classList.remove('is-closing');
          if (panel) panel.style.willChange = '';
          unlockBodyScroll();
        }
      }, 500);
    } else {
      unlockBodyScroll();
    }

    // Return focus to the trigger
    var triggerId = overlay.dataset.popupId;
    if (triggerId) {
      var trigger = document.querySelector('[data-popup-trigger="' + triggerId + '"]');
      if (trigger) trigger.focus();
    }
  }

  /* ---- overlay relocation ------------------------------------
     Move overlays to <body> so parent overflow/stacking contexts
     can't clip them. Tag each one so we can identify it later.
  ------------------------------------------------------------ */
  function relocateOverlays() {
    document.querySelectorAll('.pdp-popup-overlay').forEach(function (overlay) {
      if (overlay.parentNode !== document.body) {
        overlay.dataset.pdpRelocated = '1';
        document.body.appendChild(overlay);
      }
    });
  }

  /* ---- editor sync -------------------------------------------
     When Shopify re-renders a block (setting change, new child
     block, etc.) it injects a fresh overlay inside the block
     container while the old one is still on <body>. Replace the
     stale body overlay with the fresh one.
  ------------------------------------------------------------ */
  function syncOverlays() {
    // Fresh overlays are those not yet relocated to body
    var fresh = document.querySelectorAll('.pdp-popup-overlay:not([data-pdp-relocated])');
    fresh.forEach(function (newOverlay) {
      var id = newOverlay.dataset.popupId;
      if (id) {
        // Remove any stale relocated overlay with the same popup-id
        var stale = document.querySelector(
          '.pdp-popup-overlay[data-pdp-relocated][data-popup-id="' + id + '"]'
        );
        if (stale) {
          // Clean up scroll lock if stale was mid-close
          if (stale.classList.contains('is-open') || stale.classList.contains('is-closing')) {
            unlockBodyScroll();
          }
          stale.remove();
        }
      }
      newOverlay.dataset.pdpRelocated = '1';
      document.body.appendChild(newOverlay);
    });
  }

  /* ---- inline trigger relocation (size chart) ---------------- */
  function relocateInlineTriggers() {
    document.querySelectorAll('[data-inline-option-name]').forEach(function (wrapper) {
      var name = (wrapper.dataset.inlineOptionName || '').trim().toLowerCase();
      if (!name) return;

      var trigger = wrapper.querySelector('.pdp-popup-trigger');
      if (!trigger) return;

      var rows = document.querySelectorAll('.simple-variant-picker__label-row[data-option-name]');
      var targetRow = null;
      rows.forEach(function (row) {
        if ((row.dataset.optionName || '').trim().toLowerCase() === name) {
          targetRow = row;
        }
      });

      if (!targetRow) return;

      // Avoid duplicating
      if (targetRow.querySelector('.pdp-popup-inline-trigger')) return;

      var container = document.createElement('div');
      container.className = 'pdp-popup-inline-trigger';
      container.appendChild(trigger);
      targetRow.appendChild(container);
    });
  }

  /* ---- event delegation -------------------------------------- */
  document.addEventListener('click', function (e) {
    // Open trigger
    var trigger = e.target.closest('[data-popup-trigger]');
    if (trigger) {
      var id = trigger.dataset.popupTrigger;
      var overlay = document.querySelector('.pdp-popup-overlay[data-popup-id="' + id + '"]');
      if (overlay) {
        e.preventDefault();
        openOverlay(overlay);
      }
      return;
    }

    // Close button
    var closeBtn = e.target.closest('.pdp-popup__close');
    if (closeBtn) {
      var closingOverlay = closeBtn.closest('.pdp-popup-overlay');
      if (closingOverlay) closeOverlay(closingOverlay);
      return;
    }

    // Backdrop click
    if (e.target.classList.contains('pdp-popup__backdrop')) {
      var backdropOverlay = e.target.closest('.pdp-popup-overlay');
      if (backdropOverlay) closeOverlay(backdropOverlay);
    }
  });

  // Escape key — close topmost open overlay
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openOverlays = document.querySelectorAll('.pdp-popup-overlay.is-open');
    if (openOverlays.length) {
      closeOverlay(openOverlays[openOverlays.length - 1]);
    }
  });

  /* ---- init -------------------------------------------------- */
  function init() {
    relocateOverlays();
    relocateInlineTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor: section/block re-rendered — swap stale overlays for fresh ones
  document.addEventListener('shopify:section:load', function () {
    syncOverlays();
    relocateInlineTriggers();
  });

  // Editor: block selected — re-check inline triggers in case of a fresh render
  document.addEventListener('shopify:block:select', function () {
    syncOverlays();
    relocateInlineTriggers();
  });
})();
